"use strict";
document.addEventListener("DOMContentLoaded", () => {
  const area = document.getElementById("contact-form-area");
  if (!area) return;

  // ★ この領域内のフォームだけを対象にする
  const form = area.querySelector(".wpcf7 form");
  if (!form) return;

  const btnConfirm = area.querySelector("#cf7-confirm-btn");
  const wrapFinal = area.querySelector("#cf7-final-submit-wrap");
  const btnBack = area.querySelector("#cf7-back-btn");
  const confirmView = area.querySelector("#cf7-confirm-view");
  if (!btnConfirm || !wrapFinal || !btnBack || !confirmView) return;

  // 確認側
  const cvName = area.querySelector("#cv-name");
  const cvEmail = area.querySelector("#cv-email");
  const cvCompany = area.querySelector("#cv-company");
  const cvDetail = area.querySelector("#cv-detail");

  const privacy = form.querySelector('input[name="privacy"]');

  const toConfirm = () => {
    if (!form.reportValidity()) {
      form.querySelector(":invalid")?.focus();
      return;
    }
    if (privacy && !privacy.checked) {
      alert("プライバシーポリシーに同意してください。");
      privacy.focus();
      return;
    }

    // ★ このフォームの実データを必ず取得
    const fd = new FormData(form);
    // 一度だけ中身確認（開発時）
    // console.table([...fd.entries()]);

    // CF7 のショートコード名で読む
    if (cvName) cvName.textContent = fd.get("name-kanji") ?? "";
    if (cvEmail) cvEmail.textContent = fd.get("email") ?? "";
    if (cvCompany) cvCompany.textContent = fd.get("company-name") ?? "";
    if (cvDetail) cvDetail.textContent = fd.get("detail") ?? "";

    // 表示切替
    confirmView.style.display = "";
    wrapFinal.style.display = "";
    btnConfirm.hidden = true;

    // タイトル側を隠したい場合（l-lower に is-confirm を付与）
    document.querySelector(".l-lower")?.classList.add("is-confirm");

    wrapFinal.querySelector('[type="submit"]')?.focus();
  };

  const toEdit = () => {
    document.querySelector(".l-lower")?.classList.remove("is-confirm");
    confirmView.style.display = "none";
    wrapFinal.style.display = "none";
    btnConfirm.hidden = false;
    btnConfirm.focus();
  };

  btnConfirm.addEventListener("click", toConfirm);
  btnBack.addEventListener("click", toEdit);

  // CF7 イベントはページ全体に飛ぶ → 対象フォームだけ処理
  document.addEventListener("wpcf7mailsent", (e) => {
    if (e.target !== form) return;
    window.location.href = "/redlightlab/contact/thanks/";
  });
  document.addEventListener("wpcf7invalid", (e) => {
    if (e.target !== form) return;
    toEdit();
  });
});
